import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import moment from 'moment'
import * as React from 'react'
import DatePicker from 'react-datepicker'
import MaskedInput from 'react-input-mask'

interface IComponentProps {
  className?: string
  minDate?: number
  name?: string
  onChange: (newDate?: number) => void
  required?: boolean
  value?: number
}

export default class DateSelector extends React.PureComponent<IComponentProps> {
  private dateComponent: any
  private focus: boolean

  constructor(props: any) {
    super(props)

    this.focus = true
  }

  public render() {
    return (
      <div
        className={classNames(
          'input-group datePickerContainer',
          this.props.className,
        )}
        style={{ flexWrap: 'nowrap' }}
      >
        <DatePicker
          customInput={
            <MaskedInput mask='99/99/9999' placeholder='MM/DD/YYYY' />
          }
          name={this.props.name}
          showMonthDropdown={true}
          showYearDropdown={true}
          className='form-control'
          todayButton='Today'
          ref={(r: any) => {
            this.dateComponent = r
          }}
          popperModifiers={[
            {
              name: 'offset',
              options: {
                offset: [0, 8],
              },
            },
            {
              name: 'preventOverflow',
              options: {
                boundary: 'viewport',
              },
            },
          ]}
          minDate={
            this.props.minDate
              ? moment.unix(this.props.minDate).toDate()
              : undefined
          }
          required={this.props.required}
          selected={
            this.props.value && this.props.value > 0
              ? moment.unix(this.props.value).toDate()
              : null
          }
          onChange={(date: Date | null) => this.handleChange(date)}
        />
        <div className='input-group-append'>
          <span
            className='input-group-text'
            onClick={() => this.toggleDatePicker()}
            style={{ cursor: 'pointer' }}
          >
            <FontAwesomeIcon icon={['fal', 'calendar']} />
          </span>
        </div>
      </div>
    )
  }

  private handleChange(startDate: Date | null) {
    this.props.onChange(
      startDate === null ? undefined : moment(startDate).unix(),
    )
  }

  private toggleDatePicker() {
    this.dateComponent.setOpen(this.focus)
    this.focus = !this.focus
  }
}
